import Component from './invite-friends'

export default Component